import { Spin } from 'antd'
import classNames from 'classnames'
import React from 'react'

import { MenuItemType } from '../../Type'

const TabBarItem: React.FC<MenuItemType> = ({ title, icon, selected, onClick, loading }) => {
  const selectedClass = selected ? 'text-secondary' : ''

  return (
    <div
      className="text-center text-gray pointer"
      onClick={() => onClick(undefined)}
      aria-hidden="true">
      <div className={classNames(selectedClass, 'icon mb-1')}>
        <Choose>
          <When condition={loading}>
            <Spin size="default" />
          </When>
          <Otherwise>{icon}</Otherwise>
        </Choose>
      </div>
      <div className="text-sm">
        <span className={selectedClass}>{title}</span>
      </div>
    </div>
  )
}

export default TabBarItem
